var lib_core = require("lib-core");

/**
 * @constructor
 */
var ZoomingStateMachine = function (root, zoomingModel) {
    var self = this;
    self.root = root;
    self.cameraModel = zoomingModel.parent();
    self.zoomingModel = zoomingModel;

    lib_core.StateMachine.call(self, null, null, this.zoomingModel.scope());

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_WHEEL;
        },
        function(cEvent){
            var steps = cEvent.data('intDelta');
            var offsetX = cEvent.data('mouseCoord').getX();
            var offsetY = cEvent.data('mouseCoord').getY();
            self.zoomingModel.zoom(steps, offsetX, offsetY);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ZOOM_IN_BUTTON || 
                    cEvent.isKeyPressed( 'C_plus'));
        },
        function(cEvent){
            self.zoomingModel.zoomCenter(1);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ZOOM_OUT_BUTTON || 
                    cEvent.isKeyPressed( 'C_minus'));
        },
        function(cEvent){
            self.zoomingModel.zoomCenter(-1);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ZOOM_TO_FIT_BUTTON ||
                    cEvent.isKeyPressed( 'z', 'C_0') );
        },
        function(cEvent){
            self.zoomingModel.zoomToFit();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.isKeyPressed( 'C_9');
        },
        function(cEvent){
            self.zoomingModel.zoomSelection();
        }, "Zoom selection"
    );

    // TODO: add touch zooming to selecting, adding SM? if not: touch zooming in different own SM
    // touch zooming: not tested!
    self.addTransition("idle", "zooming",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TRANSFORM_START;
        },
        function(cEvent){
            self.viewS_start = self.cameraModel.viewS();
            self.viewX_start = self.cameraModel.viewX();
            self.viewY_start = self.cameraModel.viewY();

            self.centerX     = cEvent.data('gesture').pageX;
            self.centerY     = cEvent.data('gesture').pageY;
        }
    );

    self.addTransition("zooming", "zooming",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TRANSFORM;
        },
        function(cEvent){
            var scale = cEvent.data('gesture').scale;
            var x     = self.centerX;
            var y     = self.centerY;

            var changeX = (1 / scale - 1) * x / self.viewS_start;
            var changeY = (1 / scale - 1) * y / self.viewS_start;

            self.cameraModel.viewS(scale * self.viewS_start);
            self.cameraModel.viewX(self.viewX_start + changeX + cEvent.data('gesture').deltaX / self.cameraModel.viewS());
            self.cameraModel.viewY(self.viewY_start + changeY + cEvent.data('gesture').deltaY / self.cameraModel.viewS());
        }
    );

    self.addTransition("zooming", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_TRANSFORM_END;
        },
        function(cEvent){
            self.viewS_start = self.cameraModel.viewS();
            self.viewX_start = self.cameraModel.viewX();
            self.viewY_start = self.cameraModel.viewY();

            self.centerX     = cEvent.data('gesture').pageX;
            self.centerY     = cEvent.data('gesture').pageY;
        }
    );

};
lib_core.inherit(ZoomingStateMachine, lib_core.StateMachine);

module.exports = ZoomingStateMachine;
